// Static training content. Update every 4 months as guidance changes.

export const PHISHING_INTRO = {
  eyebrow: "Section 1",
  title: "What is phishing & how to avoid it",
  lede: "Phishing is when someone pretends to be a person or organisation you trust — a coworker, a bank, IT support — to trick you into clicking a bad link, sharing a password, or sending money. At Mobile Crisis Regina we handle sensitive information, so spotting these scams protects our clients and our team.",
};

export const RED_FLAGS = [
  {
    icon: "Clock",
    title: "Urgency & pressure",
    text: "\u201CAct within 24 hours or your account is deleted.\u201D Scammers rush you so you won\u2019t stop to think.",
  },
  {
    icon: "Link",
    title: "Suspicious links",
    text: "Hover over links before clicking. Watch for misspelled or odd domains like mcsreginaa-helpdesk.com.",
  },
  {
    icon: "At",
    title: "Mismatched sender",
    text: "The display name may say \u201CIT Support\u201D but the real address is a stranger. Always check the full email address.",
  },
  {
    icon: "Key",
    title: "Requests for credentials",
    text: "Legitimate services never ask for your password or card number through an email link.",
  },
  {
    icon: "CurrencyDollar",
    title: "Money & gift cards",
    text: "Unexpected requests to buy gift cards or move money are almost always a scam \u2014 even if the boss \u2018sent\u2019 it.",
  },
  {
    icon: "Warning",
    title: "Too good / too scary",
    text: "You won a prize, or you\u2019re in trouble. Strong emotions are a tool attackers use to cloud your judgement.",
  },
];

export const SAFE_HABITS = [
  "Slow down. Urgency is the scammer\u2019s best weapon \u2014 take a breath before you act.",
  "Verify through a channel you already trust. Call or message the person directly using a known number.",
  "Hover over links to preview the real destination before clicking.",
  "Never enter your password or personal details from a link in an email.",
  "When in doubt, don\u2019t click \u2014 report it to your admin or IT contact.",
  "If you slipped up, change your password immediately and report it. Fast action limits the damage.",
];

export const FAQS = [
  {
    q: "What should I do if I think an email is phishing?",
    a: "Don\u2019t click any links or open attachments. Don\u2019t reply. Report it to your administrator or IT contact, then delete it. When unsure, it\u2019s always safer to ask first.",
  },
  {
    q: "I clicked a suspicious link \u2014 what now?",
    a: "Don\u2019t panic, but act fast. If you entered any password, change it immediately. Disconnect from the internet if you downloaded anything, and report the incident to your admin right away so we can protect other accounts.",
  },
  {
    q: "How can I tell a real link from a fake one?",
    a: "Hover your mouse over the link (or long-press on mobile) to see the true web address. Look closely for misspellings, extra words, or strange domains. When the visible text and the real address don\u2019t match, treat it as dangerous.",
  },
  {
    q: "The email came from my manager \u2014 can I trust it?",
    a: "Not automatically. Attackers often impersonate managers and coworkers (\u2018Business Email Compromise\u2019). If a message asks for money, gift cards, or sensitive data, confirm it in person or by phone using a number you already know.",
  },
  {
    q: "Are text messages and phone calls phishing too?",
    a: "Yes. \u2018Smishing\u2019 (text) and \u2018vishing\u2019 (voice calls) use the same tricks. Be just as cautious with unexpected texts and calls that create urgency or ask for information.",
  },
  {
    q: "Why does phishing matter for Mobile Crisis Regina specifically?",
    a: "We hold confidential information about vulnerable people. A single compromised account could expose client data or disrupt our 24/7 service. Staying alert to phishing is part of protecting the community we serve.",
  },
  {
    q: "How often should I take this training?",
    a: "The content is refreshed roughly every four months. You can retake the test any time \u2014 your administrator can see your results and will follow up if anything needs clarifying.",
  },
];
